import { Dimensions, DimensionValue } from 'react-native';

export const maxHeight = 590;
export const maxHeightMobile = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.15
}px` as DimensionValue;

export const rowHeight = 74;
